import { Typography } from "@mui/material";
import { useState } from "react";
import {
  type CreateParams,
  type Identifier,
  type RaRecord,
  SaveButton,
  useRedirect,
} from "react-admin";

import { BaseModal } from "@/components/modal";
import { MODULE_NAMES } from "@/constants/modules";
import { useCountries } from "@/modules/countries";

import { RewardType } from "./constants";
import { type LeadReportRecord } from "./types";

export const SaveButtonWithModal = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const redirect = useRedirect();
  const [countriesList, setCountriesList] = useState<string[]>([]);
  const { data: { countriesObject = {} } = {} } = useCountries();

  const onSuccess = (
    data: RaRecord<Identifier>,
    variables: CreateParams<RaRecord<Identifier>>,
  ) => {
    const typedData = data as LeadReportRecord;
    const variablesData = variables.data as LeadReportRecord;
    const variablesCountries = variablesData.countries ?? [];
    const variablesRewardType = variablesData.rewardType;
    const dataCountries = typedData.countries ?? [];

    if (
      variablesRewardType !== RewardType.MAX_FOR_COUNTRY ||
      variablesCountries.length === dataCountries.length
    ) {
      redirect(`/${MODULE_NAMES.LEAD_REPORT}`);
    } else {
      const notIncludedCountries = variablesCountries.filter(
        (country: string) => !dataCountries.includes(country),
      );
      setCountriesList(notIncludedCountries);
      setModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    redirect(`/${MODULE_NAMES.LEAD_REPORT}`);
    setModalOpen(false);
  };

  return (
    <>
      <SaveButton
        label="Create"
        alwaysEnable
        mutationOptions={{ onSuccess }}
        type="button"
      />
      <BaseModal
        title="Новый отчет"
        open={modalOpen}
        onClose={handleCloseModal}
      >
        <div>
          <div>Следующие страны не вошли в отчёт:</div>
          {countriesList.map((country, index) => (
            <Typography
              fontWeight="bold"
              component="span"
              key={country}
            >{`${countriesObject[country]}${index < countriesList.length - 1 ? ", " : ""}`}</Typography>
          ))}
        </div>
      </BaseModal>
    </>
  );
};
